import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Users } from 'lucide-react';
import { LogoIsotipo } from '../components/Logo';
import { PrimaryButton } from '../components/Button';
import api, { formatApiError } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

export default function AcceptInvitation() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const token = params.get('token');
    const { user, refreshMe } = useAuth();
    const [preview, setPreview] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!token) { setError('Token inválido'); return; }
        api.get(`/invitations/preview/${token}`).then((r) => setPreview(r.data)).catch((e) => setError(formatApiError(e)));
    }, [token]);

    const accept = async () => {
        setLoading(true);
        setError('');
        try {
            await api.post(`/invitations/accept/${token}`);
            await refreshMe();
            navigate('/home', { replace: true });
        } catch (e) { setError(formatApiError(e)); }
        finally { setLoading(false); }
    };

    // If not logged in, redirect to login with redirect back
    useEffect(() => {
        if (user === false) {
            const back = encodeURIComponent(`/aceptar-invitacion?token=${token}`);
            navigate(`/login?redirect=${back}`, { replace: true });
        }
    }, [user, token, navigate]);

    return (
        <div className="fixed inset-0 flex flex-col text-white overflow-y-auto" style={{ background: 'linear-gradient(180deg, #5B5FDB 0%, #4346A3 100%)' }} data-testid="accept-invitation-screen">
            <div className="flex-1 flex flex-col items-center justify-center px-8 py-12 max-w-md mx-auto w-full">
                <LogoIsotipo size={120} className="mb-6" />

                {error ? (
                    <div className="bg-red-500/20 border border-red-300/60 text-white rounded-2xl p-4 text-center text-sm" data-testid="accept-error">
                        {error}
                    </div>
                ) : !preview ? (
                    <div className="py-10 text-white/80">Cargando invitación...</div>
                ) : (
                    <>
                        <p className="text-white/90 mb-1">Te invitaron a unirte a</p>
                        <h2 className="text-3xl font-bold mb-5">{preview.family_name}</h2>
                        <div className="w-24 h-24 bg-white/15 rounded-full flex items-center justify-center mb-5 border border-white/30">
                            <Users className="w-10 h-10 text-white/80" />
                        </div>
                        <p className="text-white/80 text-sm mb-2">{preview.members_count} miembros</p>
                        <p className="text-white/70 text-xs mb-8">Invitación para {preview.invited_email}</p>
                        <PrimaryButton onClick={accept} loading={loading} testId="accept-confirm-btn">Aceptar invitación</PrimaryButton>
                    </>
                )}

                <button onClick={() => navigate('/intro')} className="mt-6 text-white/80 hover:text-white text-sm" data-testid="accept-back">
                    No, gracias
                </button>
            </div>
        </div>
    );
}
